import React from "react";

const countryCodeByName = {
  argentina: "AR",
  ecuador: "EC",
  uruguay: "UY",
  peru: "PE",
  mexico: "MX",
  colombia: "CO",
  "costa rica": "CR",
  usa: "US",
  dinamarca: "DK",
  espana: "ES",
};

const getCountryCode = (country) => {
  if (!country) return "";

  const normalizedCountry = country
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  return countryCodeByName[normalizedCountry] || "";
};

export default function CountryFlag({ country }) {
  const countryCode = getCountryCode(country);

  if (!countryCode) return null;

  return (
    <img
      src={`https://flagcdn.com/20x15/${countryCode.toLowerCase()}.png`}
      alt={`Bandera de ${country}`}
      width="20"
      height="15"
      className="mr-2"
    />
  );
}
